<template>
  <v-container id="contactos-forms" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-contacts-outline" inline class="px-5 py-3" title="Contactos">
      <template v-if="$can('M_contactos_edita')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="nuevoContacto">
          <v-icon large color="#ac8a2e">
            mdi-contacts-outline
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="contactos"
        :search.sync="search"
        :sort-by="['nombre']"
        :sort-desc="[false]"
        multi-sort
      >
        <template v-if="$can('M_parametros')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
    <contactos-form :mode="mode" :show="mostrarContactoForm" :a-editar="contactoEditar" @update="updateContactos" @close="mostrarContactoForm = $event" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'
  import ContactosForm from '../altas/ContactosForm'

  export default {
    name: 'Contactos',
    components: {
      confirm,
      ContactosForm,
    },
    data () {
      return {
        mostrarContactoForm: false,
        search: undefined,
        headers: [
          { text: 'Nombre', sortable: false, value: 'nombre' },
          { text: 'Razón social', value: 'razon_social' },
          { text: 'Cuit', value: 'cuit' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        contactos: [],
        contactoEditar: null,
        editedIndex: -1,
      }
    },
    computed: {
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getContactos()
    },
    methods: {
      nuevoContacto () {
        this.editedIndex = -1
        this.mostrarContactoForm = true
      },
      getContactos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contactos' }).then(response => { this.contactos = response })
      },
      updateContactos () {
        this.getContactos()
        this.mostrarContactoForm = false
      },
      editItem (item) {
        this.editedIndex = this.contactos.indexOf(item)
        this.contactoEditar = Object.assign({}, item)
        this.mostrarContactoForm = true
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },
      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/contactos/' + item.id,
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Contacto eliminado exitosamente'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getContactos()
      },
    },
  }
</script>
